export function reduceString(string: string, limitBefore: number, limitAfter: number) {
  return `${string.substring(0, limitBefore)}...${string.substring(string.length - limitAfter)}`;
}

export const reduceAddress = (string: string = "", shorter = false) =>
  reduceString(string, 6 - (shorter ? 2 : 0), 4 - (shorter ? 2 : 0));
